import { createSolanaAddressId } from '@pkg/solana'
import type { SolanaConverterArgs } from '../type'

export function fromIsRelated(args: SolanaConverterArgs): boolean {
  const { transaction, relatedAddresses } = args

  if (!transaction.transaction.message.accountKeys) {
    return false
  }

  const signers = transaction.transaction.message.accountKeys.map((key) =>
    createSolanaAddressId({
      address: key.pubkey.toString(),
    }),
  )

  if (!signers.some((signer) => relatedAddresses.has(signer))) {
    return false
  }

  return true
}
